import EditIcon from "@mui/icons-material/Edit";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import { updateEvent } from "../../../../../services/event.service";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CurrencyInput from "react-currency-input-field";
import { ModalComponent } from "../../../../../ui-components/Modal";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
} from "../../../../AdminDashboard/modalStyle";

// estilo antigo removido: adminModalSx é o padrão

interface Event {
  active: boolean;
  cover: string;
  created_at: Date;
  description: string;
  ends_at: Date;
  name: string;
  updated_at: Date;
  starts_at: Date;
  id: number;
  limitdate: Date;
  event_data: any;
  event_address: string;
}

export default function UpdateButton({
  id,
  updateEvents,
  event,
}: {
  id: number;
  updateEvents: Function;
  event: Event;
}) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const parseBRLToNumber = (value: any) => {
    if (typeof value !== "string") {
      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    }
    const cleaned = value
      .replace(/[^\d,.-]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : 0;
  };

  const safeParseEventData = (data: any) => {
    try {
      if (!data) return {};
      if (typeof data === "string") return JSON.parse(data);
      return data;
    } catch {
      return {};
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData: any = Object.fromEntries(new FormData(e.target).entries());

    const currentEventData = safeParseEventData(event.event_data);

    const reqObj = {
      name: formData.name,
      active: formData.active === "true",
      description: formData.description,
      starts_at: formData.starts_at,
      ends_at: formData.ends_at,
      limitdate: formData.limitdate,
      event_address: formData.event_address,
      event_data: JSON.stringify({
        autoral: {
          subscription_price_1: parseBRLToNumber(
            formData.subscription_price_1_autoral
          ),
          subscription_price_2: parseBRLToNumber(
            formData.subscription_price_2_autoral
          ),
          table_price_1: parseBRLToNumber(formData.table_price_1_autoral),
          table_price_2: parseBRLToNumber(formData.table_price_2_autoral),
          chair_price_1: parseBRLToNumber(formData.chair_price_1_autoral),
          chair_price_2: parseBRLToNumber(formData.chair_price_2_autoral),
          percentage: formData.percentage_autoral,
        },
        alimentacao: {
          subscription_price_1: parseBRLToNumber(
            formData.subscription_price_1_alimentacao
          ),
          subscription_price_2: parseBRLToNumber(
            formData.subscription_price_2_alimentacao
          ),
          table_price_1: parseBRLToNumber(formData.table_price_1_alimentacao),
          table_price_2: parseBRLToNumber(formData.table_price_2_alimentacao),
          chair_price_1: parseBRLToNumber(formData.chair_price_1_alimentacao),
          chair_price_2: parseBRLToNumber(formData.chair_price_2_alimentacao),
          percentage: formData.percentage_alimentacao,
          bike: parseBRLToNumber(formData.bike_alimentacao),
          trailer: parseBRLToNumber(formData.trailer_alimentacao),
        },
      }),
    };
    updateEvent(reqObj, id).then(() => {
      updateEvents();
    });
    handleClose();
  };

  const { starts_at, ends_at, limitdate } = event;
  const parsedEventData: any = safeParseEventData(event.event_data);

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Editar Evento"
      >
        <Box sx={{ p: 0, pt: 0 }}>
          <form id="update-event-form" onSubmit={handleSubmit}>
            <TextField
              name="name"
              label="Nome"
              defaultValue={event.name}
              variant="outlined"
              size="small"
              fullWidth
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />
            <TextField
              name="description"
              label="Descrição"
              defaultValue={event.description}
              variant="outlined"
              size="small"
              fullWidth
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />
            <TextField
              name="event_address"
              label="Endereço do Evento"
              defaultValue={event.event_address}
              variant="outlined"
              size="small"
              fullWidth
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />
            <FormControl fullWidth size="small" sx={{ my: 2 }}>
              <InputLabel id="active-label">Evento ativo</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                label="Evento ativo"
                defaultValue={event.active ? "true" : "false"}
              >
                <MenuItem value={"true"}>Sim</MenuItem>
                <MenuItem value={"false"}>Não</MenuItem>
              </Select>
            </FormControl>
            <TextField
              name="starts_at"
              label="Data de início"
              type="date"
              defaultValue={new Date(starts_at).toISOString().split("T")[0]}
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />
            <TextField
              name="ends_at"
              label="Data de Término"
              type="date"
              defaultValue={new Date(ends_at).toISOString().split("T")[0]}
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />
            <TextField
              name="limitdate"
              label="Data de limite para pagamento"
              type="date"
              defaultValue={new Date(limitdate).toISOString().split("T")[0]}
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />

            <Typography
              id="modal-modal-title"
              sx={{ m: 4, textAlign: "center" }}
              variant="h6"
              component="h2"
            >
              Tabela de Valores - Marcas Autorais
            </Typography>

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo de Inscrição 1 Dia:{" "}
            </Typography>
            <CurrencyInput
              id="subscription_price_1_autoral"
              name="subscription_price_1_autoral"
              prefix="R$"
              placeholder="Custo de Inscrição 1 Dia"
              defaultValue={
                parsedEventData?.["autoral"]?.subscription_price_1 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo de Inscrição 2 Dias:{" "}
            </Typography>
            <CurrencyInput
              id="subscription_price_2_autoral"
              name="subscription_price_2_autoral"
              prefix="R$"
              placeholder="Custo de Inscrição 2 Dia"
              defaultValue={
                parsedEventData?.["autoral"]?.subscription_price_2 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Mesa 1 Dia:{" "}
            </Typography>
            <CurrencyInput
              id="table_price_1_autoral"
              name="table_price_1_autoral"
              prefix="R$"
              placeholder="Custo da Mesa"
              defaultValue={parsedEventData?.["autoral"]?.table_price_1 || 0}
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Mesa 2 Dias:{" "}
            </Typography>
            <CurrencyInput
              id="table_price_2_autoral"
              name="table_price_2_autoral"
              prefix="R$"
              placeholder="Custo da Mesa"
              defaultValue={parsedEventData?.["autoral"]?.table_price_2 || 0}
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Cadeira 1 Dia:{" "}
            </Typography>
            <CurrencyInput
              id="chair_price_1_autoral"
              name="chair_price_1_autoral"
              prefix="R$"
              placeholder="Custo da Cadeira"
              defaultValue={parsedEventData?.["autoral"]?.chair_price_1 || 0}
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
                marginBottom: 8,
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Cadeira 2 Dias:{" "}
            </Typography>
            <CurrencyInput
              id="chair_price_2_autoral"
              name="chair_price_2_autoral"
              prefix="R$"
              placeholder="Custo da Cadeira"
              defaultValue={parsedEventData?.["autoral"]?.chair_price_2 || 0}
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
                marginBottom: 8,
              }}
            />

            <TextField
              required
              id="percentage_autoral"
              name="percentage_autoral"
              label="Porcentagem de Vendas"
              fullWidth
              defaultValue={parsedEventData?.["autoral"]?.percentage || 0}
              autoComplete="description"
              variant="outlined"
              size="small"
              type="number"
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />

            <Typography
              id="modal-modal-title"
              sx={{ m: 4, textAlign: "center" }}
              variant="h6"
              component="h2"
            >
              Tabela de Valores - Praça de Alimentação
            </Typography>

            {/* <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo de Inscrição 1 Dia:{" "}
            </Typography>
            <CurrencyInput
              id="subscription_price_1_alimentacao"
              name="subscription_price_1_alimentacao"
              prefix="R$"
              placeholder="Custo de Inscrição 1 Dia"
              defaultValue={
                parsedEventData?.["alimentacao"]?.subscription_price_1 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            /> */}

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo de Inscrição 2 Dias:{" "}
            </Typography>
            <CurrencyInput
              id="subscription_price_2_alimentacao"
              name="subscription_price_2_alimentacao"
              prefix="R$"
              placeholder="Custo de Inscrição 2 Dia"
              defaultValue={
                parsedEventData?.["alimentacao"]?.subscription_price_2 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            {/* <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Mesa 1 Dia:{" "}
            </Typography>
            <CurrencyInput
              id="table_price_1_alimentacao"
              name="table_price_1_alimentacao"
              prefix="R$"
              placeholder="Custo da Mesa"
              defaultValue={
                parsedEventData?.["alimentacao"]?.table_price_1 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            /> */}

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Mesa 2 Dias:{" "}
            </Typography>
            <CurrencyInput
              id="table_price_2_alimentacao"
              name="table_price_2_alimentacao"
              prefix="R$"
              placeholder="Custo da Mesa"
              defaultValue={
                parsedEventData?.["alimentacao"]?.table_price_2 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            {/* <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Cadeira 1 Dia:{" "}
            </Typography>
            <CurrencyInput
              id="chair_price_1_alimentacao"
              name="chair_price_1_alimentacao"
              prefix="R$"
              placeholder="Custo da Cadeira"
              defaultValue={
                parsedEventData?.["alimentacao"]?.chair_price_1 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
                marginBottom: 8,
              }}
            /> */}

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Custo da Cadeira 2 Dias:{" "}
            </Typography>
            <CurrencyInput
              id="chair_price_2_alimentacao"
              name="chair_price_2_alimentacao"
              prefix="R$"
              placeholder="Custo da Cadeira"
              defaultValue={
                parsedEventData?.["alimentacao"]?.chair_price_2 || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
                marginBottom: 8,
              }}
            />

            <TextField
              required
              id="percentage_alimentacao"
              name="percentage_alimentacao"
              label="Porcentagem de Vendas"
              fullWidth
              defaultValue={parsedEventData?.["alimentacao"]?.percentage || 0}
              autoComplete="description"
              variant="outlined"
              size="small"
              type="number"
              sx={{
                my: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Bike:{" "}
            </Typography>
            <CurrencyInput
              id="bike_alimentacao"
              name="bike_alimentacao"
              prefix="R$"
              placeholder="Custo da Bike"
              defaultValue={
                parsedEventData?.["alimentacao"]?.bike || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
              }}
            />

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Trailer:{" "}
            </Typography>
            <CurrencyInput
              id="trailer_alimentacao"
              name="trailer_alimentacao"
              prefix="R$"
              placeholder="Custo do Trailer"
              defaultValue={
                parsedEventData?.["alimentacao"]?.trailer || 0
              }
              decimalsLimit={2}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 6,
                padding: 10,
                width: "100%",
                marginBottom: 8,
              }}
            />
          </form>
        </Box>
        <Box
          sx={{ pt: 2, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={adminButtonOutlinedSx}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            form="update-event-form"
            variant="contained"
            sx={adminButtonPrimarySx}
          >
            Alterar
          </Button>
        </Box>
      </ModalComponent>
      <IconButton
        onClick={() => {
          handleOpen();
          updateEvents();
        }}
      >
        <EditIcon />
      </IconButton>
    </>
  );
}
